import { render, staticRenderFns } from "./Deliveries.vue?vue&type=template&id=7dbd5884&scoped=true&"
import script from "./Deliveries.vue?vue&type=script&lang=js&"
export * from "./Deliveries.vue?vue&type=script&lang=js&"
import style0 from "./Deliveries.vue?vue&type=style&index=0&id=7dbd5884&prod&lang=css&"
import style1 from "./Deliveries.vue?vue&type=style&index=1&id=7dbd5884&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbd5884",
  null
  
)

export default component.exports